import { z } from 'zod';
import { ComponentValidator, ComponentPayloadValidator } from '../Component';
import { AbstractPort, Port } from '../fields/AbstractPort';
import { IsolationVoltage } from '../fields/IsolationVoltage';
import { Accuracy } from '../fields/Accuracy';
import { Time } from '../fields/Time';
import { ComponentDefinition } from '../../types/ComponentDefinition';

const inputPort = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    overvoltageCategory: z.number().nullable().default(null),
}).default({
    powerFlowDirection: 'input',
});

const electrical = z
    .object({
        ports: z.tuple([inputPort]).default([{}]),
        isolationVoltage: IsolationVoltage.validator,
        accuracy: Accuracy.validator,
        responseTime: Time.validator,
    })
    .default({});

const VoltageTransducerBase = z.object({
    type: z.literal('voltageTransducer').default('voltageTransducer'),
    electrical,
});

export const VoltageTransducerValidator = ComponentValidator.merge(VoltageTransducerBase);
export const VoltageTransducerPayloadValidator = ComponentPayloadValidator.merge(VoltageTransducerBase);

export const VoltageTransducerDefinition: ComponentDefinition = {
    type: 'voltageTransducer',
    name: 'Voltage Transducer',
    plural: 'Voltage Transducers',
    indicator: 'PT',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['input'],
        displayAsSinglePort: false,
        labels: ['Input Port'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: VoltageTransducerValidator,
        payload: VoltageTransducerPayloadValidator,
    },
};

export type VoltageTransducer = z.infer<typeof VoltageTransducerValidator>;
export type VoltageTransducerPayload = z.infer<typeof VoltageTransducerPayloadValidator>;
